import { render, staticRenderFns } from "./Tutoring.vue?vue&type=template&id=2ca81d2f&scoped=true"
import script from "./Tutoring.vue?vue&type=script&lang=js"
export * from "./Tutoring.vue?vue&type=script&lang=js"
import style0 from "./Tutoring.vue?vue&type=style&index=0&id=2ca81d2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca81d2f",
  null
  
)

export default component.exports